export default "__VITE_ASSET__dc304a18__"